import api from 'utils/api';
import { getAPIBase } from 'utils/api/apiBase';

export const getCustomerPortalUrl = async () => {
  return api.get(`${getAPIBase()}/get_customer_portal_url/`).then((response) => response?.data?.url);
};


export const getCustomerSession = async (data) => {
  return api.post(`${getAPIBase()}/stripe/session/`, data).then((response) => response?.data);
};
